// extracted by mini-css-extract-plugin
export default {"versionRibbonContainer":"VersionBadge_versionRibbonContainer__tJQ9y","versionRibbon":"VersionBadge_versionRibbon__512m3","version":"VersionBadge_version__squPB"};